































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';
import {
  METHODS,
  PAYMENT_GATEWAYS,
  SERVICE_PAYMENT_STATUSES,
} from '@/constants/payment';
import ServiceOrderListFilterForm from './List/ServiceOrderListFilterForm.vue';
import ServiceOrderListFilterChip from './List/ServiceOrderListFilterChip.vue';
import { jsonToQueryString } from '../../../utils/utils';

@Component({
  components: {
    ServiceOrderListFilterForm,
    ServiceOrderListFilterChip,
  },
  computed: {
    ...mapState('Auth', {
      business: 'activeBusiness',
    }),
    ...mapState('ServiceOrder', {
      activeServiceOrder: 'activeServiceOrder',
    }),
    ...mapState('ServicePayment', {
      activeServicePayment: 'activeServicePayment',
    }),
  },
})
export default class ServiceOrderList extends Vue {
  @Prop({ default: true }) needHeader!: boolean;
  @Prop({ default: true }) needContentClass!: boolean;
  @Prop() businessOid!: string;

  options = {
    page: 1,
    itemsPerPage: 10,
    query: null,
    orderBy: null,
    orderByDirection: 'asc',
    paymentStatuses: [],
    paymentMethod: null,
  };
  paymentMethods = METHODS;
  paymentGateways = PAYMENT_GATEWAYS;
  paymentStatuses = SERVICE_PAYMENT_STATUSES;
  additionalServices = '';
  business!: Model;

  showAdditionalService = false;
  resetPage = false;

  headers = [
    { text: 'Order ID', value: 'gid' },
    {
      text: 'Payment Method',
      value: 'service_payment.method',
      align: 'left',
      sortable: false,
    },
    {
      text: this.showAdditionalService ? 'Service Items' : 'Quantity',
      value: 'service_items',
      align: 'left',
      sortable: false,
    },
    {
      text: 'Payment Status',
      value: 'service_payment.status',
      align: 'left',
      sortable: false,
    },
    {
      text: 'Expiry Date',
      value: 'expire_at',
      align: 'left',
      sortable: false,
    },
    // { text: 'Actions', value: 'actions', align: 'left', sortable: false },
  ];

  get total_available_quantity() {
    return this.business.credits?.total_available_quantity;
  }

  @Watch('options', { immediate: false })
  watchOptions(newVal, oldVal) {
    this.resetPage =
      oldVal.query != newVal.query ||
      oldVal.paymentStatuses != newVal.paymentStatuses ||
      oldVal.paymentMethod != newVal.paymentMethod;

    this.options.page = this.resetPage ? 1 : this.options.page;

    history.pushState(
      {},
      '',
      this.$route.path +
        '?' +
        jsonToQueryString({
          page: this.options.page,
          itemsPerPage: this.options.itemsPerPage,
          paymentStatuses: this.options.paymentStatuses,
          paymentMethod: this.options.paymentMethod,
          query: this.options.query,
          orderBy: this.options.orderBy,
          orderByDirection: this.options.orderByDirection,
        })
    );
  }

  async created() {
    await this.$store.dispatch('Auth/fetchUser');
  }

  handleFetch() {
    const options = {
      params: {
        search: this.options.query,
        page: this.options.page,
        per_page: this.options.itemsPerPage,
        sort:
          this.options.orderByDirection == 'desc'
            ? '-' + this.options.orderBy
            : this.options.orderBy,
        payment_statuses: this.options.paymentStatuses,
        payment_method: this.options.paymentMethod,
        expand: ['service_items', 'service_payment'],
      },
    };
    if (this.businessOid) {
      options.params['business_oid'] = this.businessOid;
    } else if (this.business) {
      options.params['business_oid'] = this.business.object_id;
    }
    return this.$store.dispatch('ServiceOrder/fetchList', options);
  }

  toRead(oid) {
    let routeName = '-service-order-read';
    if (this.$acl.check('admin')) {
      routeName = 'admin' + routeName;
    } else if (this.$acl.check('business')) {
      routeName = 'business' + routeName;
    } else {
      return;
    }
    const routeData = this.$router.resolve({
      name: routeName,
      params: {
        serviceOrderOid: oid,
      },
    });
    window.open(routeData.href, '_blank');
  }

  toCreate() {
    this.$router.push({
      name: 'business-service-order-create',
    });
  }

  handleClick(item) {
    this.toRead(item.object_id);
  }

  getASsessmentItem(serviceItems) {
    return serviceItems.find((item) => item['key'] === 'assessment');
  }
}
